// removed by extract-text-webpack-plugin
module.exports = {"maxsize":"src-components-Page----Webapp-module---maxsize---5bBpr","fh5coicon":"src-components-Page----Webapp-module---fh5coicon---2YTEz","fh5cofeatures":"src-components-Page----Webapp-module---fh5cofeatures---15eKp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/Webapp.module.scss
// module id = 425
// module chunks = 34885888655430